'use es6';

import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const InlineImageProcessingBanner = ({
  imagesToProcess,
  setShowInlineProcessingBanner
}) => {
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.inlineImagesProcessingBanner.title",
      options: {
        imagesToProcess
      }
    }),
    closeable: true,
    onClose: () => setShowInlineProcessingBanner(false),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.inlineImagesProcessingBanner.description"
    })
  });
};
InlineImageProcessingBanner.displayName = 'InlineImageProcessingBanner';
InlineImageProcessingBanner.propTypes = {
  imagesToProcess: PropTypes.string,
  setShowInlineProcessingBanner: PropTypes.func.isRequired
};
export default InlineImageProcessingBanner;